module.exports = __webpack_public_path__ + "img/source03_bg2.8104d643.png";